import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import Head from 'next/head';
import styled from 'styled-components';
import { sitemap } from '@/utils';
var HeaderStyled = styled.div.withConfig({
    displayName: "ProtocolLayout__HeaderStyled",
    componentId: "sc-m0g58-0"
})([
    "width:100%;position:relative;background:#090808;z-index:1;& *{color:#ffffff;}.protocol-header{height:72px;padding:0 53px;display:flex;align-items:center;width:840px;background:#090808;margin:0 auto;position:relative;background:#090808;}.logo{flex:1;display:flex;align-items:center;text-decoration:unset;img{width:48px;height:48px;}.title{margin-left:12px;font-size:20px;font-weight:600;line-height:24px;}}.protocol-body{width:840px;background:#090808;margin:0 auto;text-align:left;padding:88px 0 70px 0;.title{font-weight:900;font-size:56px;line-height:66px;text-align:center;}.inc{font-weight:800;font-size:24px;line-height:28px;margin-top:24px;text-align:center;}.desc{font-weight:700;font-size:20px;line-height:23px;margin-top:72px;text-align:center;}.text{font-weight:400;font-size:18px;line-height:36px;margin-top:32px;i{font-weight:700;font-size:18px;}a{color:#e0c286;font-weight:700;font-size:18px;}}.sub-text{padding:0 50px;display:inline-block;}.sub-title{font-weight:700;font-size:32px;line-height:38px;margin-top:56px;}}"
]);
var ProtocolLayout = function(param) {
    var className = param.className, children = param.children, title = param.title;
    return(/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Head, {
                children: [
                    /*#__PURE__*/ _jsx("link", {
                        rel: "shortcut icon",
                        href: "/img/favicon.ico"
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=false"
                    }),
                    /*#__PURE__*/ _jsx("title", {
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("link", {
                        rel: "canonical",
                        href: sitemap
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(HeaderStyled, {
                className: className,
                children: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "protocol-header",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "logo",
                                children: [
                                    /*#__PURE__*/ _jsx("img", {
                                        src: "/img/logo-golden.png",
                                        alt: "logo"
                                    }),
                                    /*#__PURE__*/ _jsx("h1", {
                                        className: "title",
                                        children: "DioWallet"
                                    })
                                ]
                            })
                        }),
                        children
                    ]
                })
            })
        ]
    }));
};
export default ProtocolLayout;
